import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react'
import { Cog6ToothIcon, IconButton, LightModeBox, Panel } from 'components'
import { useWorkspace } from 'components/providers'
import { useEffect } from 'react'
import { useBreakpoint, useEntevatePermission, useIntercomUtils } from 'utils'
import {
  ManageSubscriptionDrawer,
  MultipleLimitsWarning,
  SubscriptionInfo,
  SubscriptionLimitPanels,
} from '../components/subscription'

export default function SubscriptionPage() {
  const breakpoint = useBreakpoint()
  const [entevatePermission] = useEntevatePermission()
  const { workspace } = useWorkspace()
  const adminDisclosure = useDisclosure()
  useIntercomUtils(adminDisclosure.isOpen)

  useEffect(() => {
    if (!workspace) return
    if (!workspace.subscription && entevatePermission === 'entevate') adminDisclosure.onOpen()
  }, [workspace])

  const Container = breakpoint > 1 ? Panel : Box

  return (
    <Box overflow="auto">
      <Flex
        pt={2}
        px={{ base: 4, md: 0 }}
        alignSelf="stretch"
        justifyContent="space-between"
        alignItems="center"
      >
        <Text textStyle="h1">Subscription</Text>
        {entevatePermission === 'entevate' && (
          <IconButton
            aria-label="Manage Button"
            icon={<Cog6ToothIcon />}
            onClick={adminDisclosure.onOpen}
          />
        )}
      </Flex>

      <Container mt={10} p={{ base: 4, md: 10 }} mb={4}>
        <LightModeBox display="flex" flexDirection="column" gap={5}>
          <SubscriptionInfo />
          <MultipleLimitsWarning />
          <SubscriptionLimitPanels />
        </LightModeBox>
      </Container>

      <ManageSubscriptionDrawer {...adminDisclosure} />
    </Box>
  )
}
